export const getWhatsAppMetaScopesCacheKey =
  "/engagement/:app_group_id/whatsapp/meta_api_scopes/:messaging_service_id" as const;
